import { Link } from "react-router-dom";
import Slider from "react-slick";

const BannerSlider = () => {
    const sliderSettings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    return (
        <>
            <section className="herosection">
                <Slider {...sliderSettings}>
                    <div className="banner-slide">
                        <div className="banner-image">
                            <img src="assets/images/slide1.jpeg" alt="" />
                        </div>
                        <div className="site-container banner-midcontent">
                            <div className="row">
                                <div className="col-lg-7">
                                    <div className="sub-heading txt-clr-white mb-4">We Design All Kinds of Buildings</div>
                                    <div className="heading txt-clr-white mb-5"><span className="font-light">We Build Buildings</span> Professionally </div>
                                    <Link to="/projects" className="button">View Projects</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="banner-slide">
                        <div className="banner-image">
                            <img src="assets/images/slide2.jpeg" alt="" />
                        </div>
                        <div className="site-container banner-midcontent">
                            <div className="row">
                                <div className="col-lg-7">
                                    <div className="sub-heading txt-clr-white mb-4">Team Work</div>
                                    <div className="heading txt-clr-white mb-5"><span className="weight-light">That allows the
                                        Work to be</span> completed
                                        Efficiently </div>
                                    <Link to="/projects" className="button">View Projects</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="banner-slide">
                        <div className="banner-image">
                            <img src="assets/images/slide3.jpeg" alt="" />
                        </div>
                        <div className="site-container banner-midcontent">
                            <div className="row">
                                <div className="col-lg-7">
                                    <div className="sub-heading txt-clr-white mb-4">Team Work</div>
                                    <div className="heading txt-clr-white mb-5"><span className="weight-light">That allows the
                                        Work to be</span> completed
                                        Efficiently </div>
                                    <Link to="/projects" className="button">View Projects</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </Slider>
            </section>
        </>
    )
}
export default BannerSlider;